"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateState = exports.getStates = exports.getStateById = exports.defaultStateData = exports.createState = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultStateData = exports.defaultStateData = {
  id: undefined,
  enabled: true,
  name: '',
  code: '',
  country: '',
  gstNumber: '',
  panNumber: ''
};
const getStateById = id => (0, _request.default)({
  url: `/states/${id}`,
  method: 'get'
});
exports.getStateById = getStateById;
const createState = data => (0, _request.default)({
  url: '/states',
  method: 'post',
  data
});
exports.createState = createState;
const updateState = (id, data) => (0, _request.default)({
  url: `/states/${id}`,
  method: 'patch',
  data
});
exports.updateState = updateState;
const getStates = query => (0, _request.default)({
  url: '/states',
  method: 'get',
  params: query
});
exports.getStates = getStates;